"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    generatingChart: {
        en: "Generating chart...",
        es: "Generando gráfico...",
    },
    verificationEmailSuccess: {
        en: "Verification email sent successfully.",
        es: "Correo de verificación enviado exitosamente.",
    },
    confirmEmailWarning: {
        en: "Log in to your email and confirm your account.",
        es: "Ingresa a tu correo y confirma tu cuenta.",
    },
    alertActivationEmail: {
        en: "Log in to your email and confirm your account to activate the alert, you will not receive alerts until the email has been verified.",
        es: "Ingresa a tu correo y confirma tu cuenta para activar la alerta, mientras no se active no recibirás alertas.",
    },
    alertActivationSMS: {
        en: "Click on the activation link we sent you through SMS to activate the alert, you will not receive alerts until you have clicked the activation link.",
        es: "Haz click en el link de activación que se te envió por SMS para activar la alerta, mientras no hagas click en el link no recibirás alertas.",
    },
    verificationEmailError: {
        en: "There was a problem trying to send the verification email. Try again later.",
        es: "Hubo un problema al enviar el correo de verificación. Intenta más tarde.",
    },
    recordSaved: {
        en: "Record {record} was saved correctly.",
        es: "El registro {record} se guardo correctamente.",
    },
    maintenanceSaved: {
        en: "Maintenance {record} was saved correctly.",
        es: "El mantenimiento {record} se guardo correctamente.",
    },
    recordDeleted: {
        en: "Record was deleted correctly.",
        es: "El registro se elimino correctamente.",
    },
    recordEdited: {
        en: "Record {record} was edited successfully",
        es: "El registro {record} se modificó con éxito",
    },
    recordInvalidated: {
        en: "Record {record} was invalidated successfully",
        es: "El usuario {username} se invalidó con éxito",
    },
    sendingCommandTitle: {
        en: "Sending Command…",
        es: "Enviando Comando...",
    },
    sendingCommandDescription: {
        en: "Unit will respond back once the command is accepted.",
        es: "En brevedad la unidad responderá si el comando fue aceptado.",
    },
    sharedDevicesExternal: {
        en: "Units shared correctly.",
        es: "Unidades compartidas correctamente.",
    },
    noDevices: {
        en: "No Unit",
        es: "Sin Unidad",
    },
    lineIsRequired: {
        en: "Line number is required.",
        es: "El numero de la linea es requerido.",
    },
    nameIsRequired: {
        en: "The name is required.",
        es: "El nombre es requerido.",
    },
    reportIsRequired: {
        en: "The report is required.",
        es: "El reporte es requerido.",
    },
    emailIsRequired: {
        en: "The email is required.",
        es: "El correo es requerido.",
    },
    phoneNumberIsRequired: {
        en: "The phone number is required.",
        es: "El numero de teléfono es requerido.",
    },
    commandIsRequired: {
        en: "The command is required.",
        es: "El comando es requerido.",
    },
    apiKeyRequired: {
        en: "The API Key is required.",
        es: "La API Key es requerido.",
    },
    hostRequired: {
        en: "The host is required.",
        es: "El host es requerido.",
    },
    sidRequire: {
        en: "The SID is required.",
        es: "El SID es requerido.",
    },
    tokenRequire: {
        en: "The token is required.",
        es: "El token de autenticación es requerido.",
    },
    messageSIDRequire: {
        en: "The message SID is required.",
        es: "El SID de mensaje es requerido.",
    },
    phoneError: {
        en: "The phone number is misspelled.",
        es: "El numero de teléfono está mal escrito.",
    },
    clientWasEnable: {
        en: "Client {name} was enable",
        es: "El cliente {name} ha sido habilitado",
    },
    clientWasDisable: {
        en: "Client {name} was disable",
        es: "El cliente {name} ha sido deshabilitado",
    },
    companyWasEnable: {
        en: "Service provider {name} was enable",
        es: "El proveedor de servicio {name} ha sido habilitado",
    },
    companyWasDisable: {
        en: "Service provider {name} was disable",
        es: "El proveedor de servicio {name} ha sido deshabilitado",
    },
    deviceModelEnable: {
        en: "Model {name} was enable",
        es: "El modelo {name} ha sido habilitado",
    },
    beforeLoadRoute: {
        en: "Please select a unit and a date first.",
        es: "Por favor primero seleccione una unidad y fecha.",
    },
    deviceModelDisable: {
        en: "Model {name} was disable",
        es: "El modelo {name} ha sido deshabilitado",
    },
    ADD_ACCOUNTS_SUCCESS: {
        en: "Added {username} successfully.",
        es: "El usuario {username} fue ingresado con éxito",
    },
    DELETE_ACCOUNTS_SUCCESS: {
        en: "Deleted user successfully.",
        es: "Se elimino con éxito.",
    },
    ADD_DEVICES_SUCCESS: {
        en: "Added Device {description} successfully.",
        es: "La unidad {description} fue ingresado con éxito.",
    },
    DELETE_DEVICES_SUCCESS: {
        en: "Deleted Device successfully.",
        es: "La unidad fue borrado con éxito.",
    },
    EDIT_DEVICES_SUCCESS: {
        en: "Device {description} was edited successfully",
        es: "La unidad {description} se modificó con éxito",
    },
    ADD_CARRIERS_SUCCESS: {
        en: "Added Carrier {description} successfully.",
        es: "El proveedor {description} fue ingresado con éxito.",
    },
    EDIT_CARRIERS_SUCCESS: {
        en: "Carrier {description} was edited successfully",
        es: "El proveedor {description} se modificó con éxito",
    },
    ADD_COMPANIES_SUCCESS: {
        en: "Added provider {name} successfully.",
        es: "El proveedor {name} fue ingresada con éxito.",
    },
    DELETE_COMPANIES_SUCCESS: {
        en: "Deleted provider successfully.",
        es: "El proveedor fue borrada con éxito.",
    },
    DELETE_LINKS_SUCCESS: {
        en: "Link deleted successfully.",
        es: "El link fue eliminado con éxito.",
    },
    EDIT_COMPANIES_SUCCESS: {
        en: "provider {name} was edited successfully",
        es: "El proveedor {name} se modificó con éxito.",
    },
    uniquenessError: {
        en: "This {field} already exists",
        es: "El {field} ya existe.",
    },
    behaviorIsRequired: {
        en: "The behavior is required.",
        es: "El comportamiento es requerido.",
    },
    allPhotosLoaded: {
        en: "All the photos from {device} have been loaded.",
        es: "Todas las fotos de {device} han sido cargadas.",
    },
    timeNotCorrect: {
        en: "You can't select a start time grater than the end time.",
        es: "No puedes seleccionar una hora inicial mayor que la final.",
    },
    recordUpdatedSuccessfully: {
        en: "Records updated successfully",
        es: "Registros actualizados correctamente",
    },
    timezoneRequired: {
        en: "The timezone is required.",
        es: "La zona horaria es requerida.",
    },
    deactivateConfirm: {
        en: "Are you sure you want to deactivate?",
        es: "¿Está seguro que quiere desactivar?",
    },
    cancelTrip: {
        en: "Trip cancellation reason.",
        es: "Razón de cancelación de viaje.",
    },
    commentRequired: {
        en: "Please add a comment.",
        es: "Agregue un comentario por favor.",
    },
    eventRequired: {
        en: "Please select a event.",
        es: "Por favor selecciona un evento.",
    },
    originRequired: {
        en: "Please select a origin geofence.",
        es: "Por favor selecciona una geocerca de origen.",
    },
    destinationRequired: {
        en: "Please select a destination geofence.",
        es: "Por favor selecciona una geocerca de destino.",
    },
    startsEndsDateError: {
        en: "The end date cannot be less or equal than start date.",
        es: "La fecha final no puede ser menor o igual a la fecha de inicio.",
    },
    startsAtRequired: {
        en: "Please select a start date.",
        es: "Por favor selecciona una fecha de inicio.",
    },
    endsAtRequired: {
        en: "Please select a end date.",
        es: "Por favor selecciona una fecha para finalizar.",
    },
    eventDescriptionRequired: {
        en: "Please add a description for the event.",
        es: "Por favor agregue una descripción para el evento.",
    },
    iconRequired: {
        en: "Please select an icon.",
        es: "Por favor seleccione un icon por favor.",
    },
    samplesRequired: {
        en: "You require at least 2 readings.",
        es: "Se require al menos 2 lecturas.",
    },
    cameraOff: {
        en: "Camera Off",
        es: "Cámara apagada",
    },
    cameraNotReady: {
        en: "Information not ready, this might take several minutes.",
        es: "La información no esta lista, esto puede tomar algunos minutos.",
    },
    cameraUnsupported: {
        en: "This Phone doesn't support live streaming, try to use a computer.",
        es: "Este teléfono no soporta esta funcionalidad, intente desde su computadora",
    },
    cameraConnectionError: {
        en: "There was a problem connecting with the camera, please try again.",
        es: "Hubo un problema al querer conectarse a la Cámara, intente de nuevo",
    },
    caeReported: {
        en: "The authorities have been notify.",
        es: "Las autoridades han sido notificadas.",
    },
    oneMonthLimit: {
        en: "You should not select more than one month, please try again.",
        es: "No debe seleccionar más de un mes, vuelva a intentarlo.",
    },
    noSelectedUnits: {
        en: "There's no selected units.",
        es: "No hay unidades seleccionadas.",
    },
    verifyEmailSuccess: {
        en: "Email verified successful.",
        es: "Correo verificado exitosamente.",
    },
    ADD_FUEL_BILL_SUCCESS: {
        en: "Fuel bill was saved correctly",
        es: "La factura de combustible se guardo correctamente",
    },
    EDIT_FUEL_BILL_SUCCESS: {
        en: "Fuel bill was edited successfully",
        es: "La factura de combustible se edito exitosamente",
    },
    FUEL_BILL_FAILED: {
        en: "There was an error while saving fuel bill",
        es: "Hubo un error al guardar la factura de combustible",
    },
    FIELDS_FAILED: {
        en: "Please fill all the fields before saving",
        es: "Por favor llene todos los campos antes de guardar.",
    },
    ADD_GAS_STATION_SUCCESS: {
        en: "Gas Station was saved correctly",
        es: "La gasolinera se guardo correctamente",
    },
    EDIT_GAS_STATION_SUCCESS: {
        en: "Gas Station was edited successfully",
        es: "La gasolinera se edito exitosamente",
    },
    GAS_STATION_FAILED: {
        en: "There was an error while saving gas station",
        es: "Hubo un error al guardar la gasolinera",
    },
    ADD_REQUESTER_SUCCESS: {
        en: "Requester was saved correctly",
        es: "El solicitante se guardo correctamente",
    },
    EDIT_REQUESTER_SUCCESS: {
        en: "Requester was edited successfully",
        es: "El solicitante se edito exitosamente",
    },
    REQUESTER_FAILED: {
        en: "There was an error while saving requester",
        es: "Hubo un error al guardar el solicitante",
    },
    odometerActivation: {
        en: "Add a value to activate the odometer.",
        es: "Agregue el valor para activar el odómetro.",
    },
    mapLoadingError: {
        en: "There was an error getting the units data, click on the refresh button or try again later.",
        es: "Hubo un error al obtener la información de la unidad, presione el botón de refrescar o intente mas tarde.",
    },
    fileMissingRequiredFields: {
        en: "Something is missing in your file, please check it and try again.",
        es: "Algo falta en tu archivo, revísalo y prueba de nuevo.",
    },
    sendEmailSucess: {
        en: "Email was sent successfully",
        es: "El correo se envió con éxito",
    },
    credentialWarning: {
        en: "A credential must be entered before adding a new unit",
        es: "Se debe de ingresar una credencial antes de agregar una nueva unidad",
    },
    activeSim: {
        en: "Sim has been activated successfully.",
        es: "La sim ha sido activada correctamente.",
    },
    deactivateSim: {
        en: "Sim has been deactivated successfully.",
        es: "La sim ha sido desactivada correctamente.",
    },
    noActiveService: {
        en: "This service is currently disabled",
        es: "Actualmente este servicio se encuentra desactivado.",
    },
    noServiceCredentials: {
        en: "This service has no credentials defined.",
        es: "Este servicio no tiene credenciales definidas.",
    },
    noServiceConfiguration: {
        en: "This service does not have a defined configuration.",
        es: "Este servicio no tiene una configuración definida.",
    },
    noCredits: {
        en: "Sorry, you don't have more credits for this month.",
        es: "Lo sentimos, no tienes créditos restantes este mes.",
    },
    successEmailSent: {
        en: "Email sent successfully.",
        es: "Correo enviado exitosamente.",
    },
    successSMSSent: {
        en: "Message sent successfully.",
        es: "Mensaje enviado exitosamente.",
    },
    deleteCompanies: {
        en: "Delete ({amount}) providers",
        es: "Eliminar ({amount}) proveedores",
    },
    deviceModelMissing: {
        en: "Model is require, please select a model.",
        es: "El modelo requerido, seleccione un modelo por favor.",
    },
    affectedDevices: {
        en: "Affected devices: {amount}.",
        es: "Dispositivos afectados: {amount}.",
    },
    noDeviceAffected: {
        en: "No devices will be affected.",
        es: "Ningún dispositivo se verá afectado.",
    },
    commandScheduled: {
        en: "The command has been scheduled successfully.",
        es: "El comando se programo con éxito.",
    },
    emptyEventList: {
        en: "No alerts have been generated in the last {minutes} minutes.",
        es: "No se han generado alertas en los últimos {minutes} minutos.",
    },
    noLogs: {
        en: "No records for the last 24 hours",
        es: "No hay registros de las ultimas 24 horas",
    },
    dataDelay: {
        en: "Data is delayed by 1 minute",
        es: "Los datos tienen un retraso de 1 minuto",
    },
    retransmissionDate: {
        en: "Retransmission date",
        es: "Fecha de retransmisión",
    },
    selectDate: {
        en: "Select date",
        es: "Seleccionar fecha",
    },
    keyIdTooltip: {
        en: "Use when driver has been assigned an ID tag",
        es: "Se debe de utilizar cuando al conductor se le ha asignado una etiqueta de identificación",
    },
    changesRequired: {
        en: "You need to make at least one change before saving.",
        es: "Necesitas hacer al menos un cambio antes de guardar.",
    },
    formulaError: {
        en: "The defined values/formula cannot be evaluated, please check the data again!",
        es: "Los valores/formula ingresados no pueden ser evaluados, por favor verificar los datos nuevamente!",
    },
    valueIsZeroError: {
        en: "Value should be greater than 0",
        es: "El valor ingresado tiene que ser mayor a 0",
    },
    maxValueError: {
        en: "Max value must be greater than Min value",
        es: "El valor Max debe ser mayor al valor Min",
    },
    serviceUpdated: {
        en: "Service configuration has been updated successfully",
        es: "La configuración del servicio se ha actualizado exitosamente",
    },
    purchaseWasSuccessful: {
        en: "Purchase was successful",
        es: "La compra se realizó con éxito",
    },
    contactYourAdministrator: {
        en: "Contact your administrator",
        es: "Contacta con tu administrador",
    },
    invalidEndDate: {
        en: "Invalid end date",
        es: "Fecha de finalización invalida",
    },
    invalidInitialDate: {
        en: "Invalid initial date",
        es: "Fecha de finalización invalida",
    },
    exceedDateRange: {
        en: "Maximum date range exceeded",
        es: "Se superó el intervalo de fechas máximo",
    },
    multimediaRequestSuccessfully: {
        en: "Media requested successfully.",
        es: "Medios solicitados exitosamente.",
    },
    requestVideoTimeout: {
        en: "Media request ended with no response.",
        es: "No se obtuvo respuesta de los medios solicitados.",
    },
    deviceUnsubscribedSuccessfully: {
        en: "Unit unsubscribed successfully",
        es: "Suscripción de la unidad cancelada exitosamente",
    },
    deviceCanceledSuccessfully: {
        en: "Unit canceled successfully",
        es: "Unidad cancelada exitosamente",
    },
    NoEventsForSelectedDates: {
        en: "There are no events for this date.",
        es: "No hay eventos para esta fecha.",
    },
    disabledRequestDisclaimer: {
        en: "Video not available while parked.",
        es: "El video no está disponible mientras está estacionado.",
    },
    resetDataPackage: {
        en: "{days} Days to reset monthly data package",
        es: "{days} Días para reiniciar el paquete de datos mensual",
    },
    deleteExtraConfig: {
        en: "All configurations will be deleted. Are you sure you want to proceed?",
        es: "Todas las configuraciones serán eliminadas. ¿Está seguro de que desea continuar?",
    },
};
exports.default = translations;
